import { triggerConfetti } from 'js/lib/confetti'
/* global IntersectionObserver */

function initGuage(loveOMeter) {
  const gauge = loveOMeter.querySelector('.js-c-gauge')
  const goal = parseInt(gauge.dataset.goal, 10)
  const value = parseInt(gauge.dataset.value, 10)

  const needle = gauge.querySelector('.js-needle')
  const progressRing = gauge.querySelector('.js-progress-ring')
  const valueText = document.querySelector('.js-value')

  // Early exit if any of the critical elements are missing
  if (!gauge || !needle || !progressRing || !valueText) {
    console.warn('Missing critical gauge elements. Aborting gauge animation.')
    return
  }

  const maxDash = 283
  const percent = Math.min(value / goal, 1)
  const minAngle = -90
  const maxAngle = 90
  const targetAngle = minAngle + (maxAngle - minAngle) * percent

  const duration = 1000
  const frameRate = 60
  const totalFrames = duration / (1000 / frameRate)
  let frame = 0

  function animate() {
    frame++
    const progress = frame / totalFrames
    const easedProgress = 1 - Math.pow(1 - progress, 3) // easeOutCubic
  
    const currentAngle = calculateAngle(minAngle, targetAngle, easedProgress)
    const currentOffset = calculateOffset(maxDash, percent, easedProgress)
    const currentValue = Math.floor(value * easedProgress)
  
    updateGauge(currentAngle, currentOffset, currentValue)
  
    if (frame < totalFrames) {
      window.requestAnimationFrame(animate)
    } else if (value >= goal) {
      triggerConfetti(true)
    }
  }

  function calculateAngle(minAngle, targetAngle, easedProgress) {
    return minAngle + (targetAngle - minAngle) * easedProgress
  }

  function calculateOffset(maxDash, percent, easedProgress) {
    return maxDash * (1 - percent * easedProgress)
  }

  function updateGauge(currentAngle, currentOffset, currentValue) {
    needle.setAttribute('transform', `rotate(${currentAngle} 100 100)`)
    progressRing.style.strokeDashoffset = currentOffset
    valueText.textContent = `${currentValue} / ${goal}`
  }

  window.requestAnimationFrame(animate)
}

function checkIfInViewport(loveOMeter) {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        initGuage(entry.target)
        obs.unobserve(entry.target)
      }
    })
  }, { threshold: 0.5 }) // Trigger when 50% of the element is visible

  observer.observe(loveOMeter)
}

function initializeAllLoveOMeters() {
  const loveOMeters = document.querySelectorAll('.js-c-love-o-meter')
  loveOMeters.forEach((loveOMeter) => {
    checkIfInViewport(loveOMeter)
  })
}

initializeAllLoveOMeters()
